import { Middleware } from 'redux';

import {
  failCalling,
  finishCalling,
  noInternetCalling,
  startCalling
} from '../actions/network';
import {
  successCreateWiki,
  successDestroyWiki,
  successReadWikisByGroup,
  successReadWikisDiff,
  successUpdateWiki
} from '../actions/wiki';
import DeleteWiki from '../apis/DeleteWiki';
import GetWikisDiff from '../apis/GetWikisDiff';
import GetWikisGroup from '../apis/GetWikisGroup';
import PostWiki from '../apis/PostWiki';
import PutWiki from '../apis/PutWiki';

const MIDDLEWARE = 'wikis';

const wikisMiddleware: Middleware = store => next => action => {
  switch (action.type) {
    case 'READ_WIKIS_BY_GROUP':
      readWikisGroup(store, action);
      break;

    case 'READ_WIKIS_DIFF':
      readWikisDiff(store, action);
      break;

    case 'CREATE_WIKI':
      createWiki(store, action);
      break;
    case 'UPDATE_WIKI':
      updateWiki(store, action);
      break;

    case 'DESTROY_WIKI':
      destroyWiki(store, action);
      break;
  }
  next(action);
};

const readWikisGroup = (store: any, action: any) => {
  const METHOD = 'readWikisGroup';
  console.log(MIDDLEWARE + ':' + 'Call API: GetWikisGroup');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new GetWikisGroup();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.group, store.getState().Account).then(
        wikis => {
          store.dispatch(successReadWikisByGroup(wikis));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const readWikisDiff = (store: any, action: any) => {
  const METHOD = 'readWikisDiff';
  console.log(MIDDLEWARE + ':' + 'Call API: GetWikisDiff');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new GetWikisDiff();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(store.getState().Account).then(
        wikis => {
          store.dispatch(successReadWikisDiff(wikis));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const createWiki = (store: any, action: any) => {
  const METHOD = 'createWiki';
  console.log(MIDDLEWARE + ':' + 'Call API: PostWiki');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new PostWiki();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.wiki, store.getState().Account).then(
        wiki => {
          store.dispatch(successCreateWiki(wiki));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const updateWiki = (store: any, action: any) => {
  const METHOD = 'updateWiki';
  console.log(MIDDLEWARE + ':' + 'Call API: PutWiki');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new PutWiki();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.wiki, store.getState().Account).then(
        wiki => {
          store.dispatch(successUpdateWiki(wiki));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const destroyWiki = (store: any, action: any) => {
  const METHOD = 'destroyWiki';
  console.log(MIDDLEWARE + ':' + 'Call API: DeleteWiki');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new DeleteWiki();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.wiki, store.getState().Account).then(
        wiki => {
          store.dispatch(successDestroyWiki(action.wiki));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

export default wikisMiddleware;



// WEBPACK FOOTER //
// ./src/middlewares/wikis.ts